// Taner Torun - Kurucu Biyografi ve İçerik Verileri

export const founderContent = {
  // Temel Bilgiler
  name: "Taner TORUN",
  title: "Kurucu & Zihin Mimarı",
  experienceYears: 20,
  
  // Uzmanlık Alanları
  expertise: [
    "Bilinçaltı Dönüşüm Eğitmeni",
    "Hipnotik Dil Kalıpları Uzmanı",
    "Nöro-Pazarlama Stratejisti",
    "Dijital Büyüme Mimarı",
    "Algı ve Dönüşüm Mühendisi"
  ],
  
  // Başlık Seçenekleri
  headlines: [
    "Dijital Büyümenin Zihin Mimarı: Taner Torun",
    "Verinin Ötesinde, Zihnin Derinliğinde: Taner Torun Metodolojisi",
    "20 Yıllık Deneyim, Sınırsız İnovasyon",
    "Görünürlükten Öteye: Tercih Edilmeyi Tasarlıyoruz",
    "Nöro-Pazarlama ile Dijital Büyümenin Yeniden Tanımı"
  ],
  
  // Uzun Biyografi (Metodoloji Sayfası İçin)
  longFormBio: {
    paragraphs: [
      {
        title: "Vizyon",
        content: "Dijital dünyada 'görünür olmak' artık yeterli değil. Gerçek başarı, markanızın hedef kitlenizin zihninde tercih edilen seçenek haline gelmesidir. 20 yıllık dijital ajans ve pazarlama deneyimimi, bilinçaltı dönüşüm eğitmenliği ve hipnotik dil kalıpları uzmanlığımla birleştirerek, markaların sadece fark edilmesini değil, hissedilmesini ve tercih edilmesini sağlayan sistemler tasarlıyorum."
      },
      {
        title: "Metodoloji",
        content: "Geliştirdiğim Nöro-UX metodolojisi, göz takibi prensiplerine dayalı kullanıcı deneyimi tasarımı, mesaj mimarisi ve davranışsal akış tasarımını bir araya getirir. Her projede kullanıcıların bilinçaltı karar mekanizmalarını analiz ediyor, duygusal tetikleyicileri stratejik olarak konumlandırıyor ve etik ikna çerçevesi içinde dönüşüm optimizasyonu yapıyorum."
      },
      {
        title: "aifabric Entegrasyonu",
        content: "Psikoloji bilimini yapay zeka ile birleştiren aifabric platformumuz, veriyi içgörüye, içgörüyü aksiyona dönüştürür. Bu sayede markanızın dijital varlığı, sadece estetik değil, ölçülebilir büyüme hedeflerine hizmet eden stratejik bir araç haline gelir."
      },
      {
        title: "Taahhüt",
        content: "Proje bazlı çalışma modelimiz, her iş birliğinde ölçülebilir sonuçlar ve şeffaf iletişim taahhüdü içerir. Etik ikna çerçevesi içinde, uzun vadeli güven ilişkileri kurarak, markanızın sürdürülebilir büyümesini hedefliyorum. 150'den fazla başarılı proje ve %240 ortalama büyüme oranı, bu yaklaşımın somut kanıtıdır."
      }
    ]
  },
  
  // Kısa Teaser (Ana Sayfa İçin)
  shortTeaser: "20 yıllık dijital deneyim ve bilinçaltı dönüşüm uzmanlığıyla, markanızın sadece görülmesini değil, tercih edilmesini tasarlıyoruz. Nöro-pazarlama ile veriyi içgörüye, içgörüyü büyümeye dönüştürün.",
  
  // Mikro İçerikler
  microCopy: {
    quote: "İnsanlar mantıkla karar verdiklerini düşünür, ama aslında duygularıyla karar verip mantıkla meşrulaştırırlar. Biz bu gerçeği tasarıma dönüştürüyoruz.",
    tagline: "Zihnin Mimarisi, Büyümenin Formülü",
    valueSentence: "Sadece tasarlamıyoruz; hissettiriyor, etkiliyor ve sempati kazanıyoruz."
  },
  
  // Kanıt Noktaları
  proofPoints: [
    { value: "150+", label: "Başarılı Proje" },
    { value: "%240", label: "Ortalama Büyüme" },
    { value: "20", label: "Yıl Deneyim" },
    { value: "Türkiye", label: "Geneli Hizmet" }
  ],
  
  // Temel Mesajlar
  keyMessages: [
    "20 yıllık derin sektör deneyimi",
    "Bilinçaltı dönüşüm ve hipnotik dil kalıpları uzmanlığı",
    "Sadece görünürlük değil, tercih edilme tasarlama",
    "Teknoloji + Psikoloji + Yapay Zeka birleşimi",
    "Etik ikna ve davranış mühendisliği",
    "Proje bazlı, ölçülebilir büyüme taahhüdü"
  ],
  
  // Nöro-Pazarlama Prensipleri
  neuroMarketingPrinciples: [
    {
      title: "Hissediyoruz",
      description: "Nöro-pazarlama ve bilinçaltı ikna teknikleriyle hedef kitlenizin duygusal tetikleyicilerini harekete geçiriyoruz."
    },
    {
      title: "Ölçekliyoruz",
      description: "aifabric platformuyla veri odaklı içgörüler üretiyor, büyüme stratejilerinizi optimize ediyoruz."
    },
    {
      title: "Sonuç Alıyoruz",
      description: "Proje bazlı çalışma modeliyle ölçülebilir başarı metrikleri ve ROI taahhüdü sunuyoruz."
    }
  ],
  
  // Marka Farklılaştırıcıları
  differentiators: [
    "Nöro-pazarlama + Yapay Zeka",
    "Proje bazlı çalışma modeli",
    "Ölçülebilir büyüme odağı",
    "Etik ikna ve davranış mühendisliği",
    "20 yıllık derin sektör deneyimi"
  ],
  
  // Hizmet Sütunları
  servicePillars: [
    {
      title: "Dijital Deneyim & Algı Mimarisi",
      description: "Kullanıcı yolculuğunu bilinçaltı prensiplerine göre tasarlıyoruz."
    },
    {
      title: "Otorite & Talep Motoru",
      description: "Markanızı sektör otoritesi haline getiren içerik ve SEO stratejileri."
    },
    {
      title: "Performans & İkna Hızlandırıcı",
      description: "Dönüşüm optimizasyonu ve hipnotik mesaj mimarisi ile satış artışı."
    }
  ],
  
  // SEO Meta Bilgileri
  seo: {
    metaTitle: "Taner Torun: Zihin Mimarı ve Dijital Büyüme Stratejisti | Medyatik",
    metaDescription: "20 yıllık deneyim, bilinçaltı dönüşüm uzmanlığı ve yapay zeka ile dijital büyüme sistemleri tasarlayan Taner Torun metodolojisini keşfedin."
  }
};

export default founderContent;
